<template>
  <div id="jumbotron" class="row m-0">
    <div id="bubble" class="col-12 col-md-4 col-lg-3 d-none d-md-block">
      <div class="text text-center">
        <div class="title tf-dm-serif text-secondary">100%</div>
        <p>
          Our Cambridge
          <br>English exams
          <br>pass rate!
        </p>
      </div>
    </div>
    <div id="welcome" class="col-12 col-md-8 col-lg-9">
      <h1 class="mt-5 pt-5">Welcome to English Matters,<br>and more!</h1>
      <p>Yes. We can help.</p>

      <div>
        <router-link class="btn btn-secondary me-4 px-4" to="/our-programs">Our Programs</router-link>
        <router-link class="btn btn-primary px-4" to="/about-english-matters">About Us</router-link>
      </div>
    </div>
  </div>

  <div id="about" class="text-center py-5">
    <p class="fw-bold text-secondary">
      ABOUT US
    </p>
    <p class="container" style="max-width: 800px">
      At <strong>English Matters</strong>, we are dedicated to empowering learners with the linguistic skills needed to excel in today’s globalized world. Now part of the <strong>Edu Circle Group</strong>, we have expanded beyond English proficiency to offer a diverse range of language programs, as well as a Personal Development Program (PDP) tailored for students to build their soft skills, which is much needed in today’s world.
    </p>
    <br><br><br>
    <div class="text-start">
      <WhyUs />
    </div>
    <br><br><br><br>
    <h2 class="text-primary">
      The limits of your language
      <br>means the limits of your world
    </h2>
    <Carousel v-bind="carouselConfig">
      <Slide v-for="slide in slides" :key="slide">
        <img class="carousel__item" :src="slide" height="300px" width="225px">
      </Slide>
    </Carousel>
  </div>
  
  <div id="classes" class="text-center pb-5">
    <p class="fw-bold text-secondary">
      ENGLISH CLASSES
    </p>
    <br>
    <h2 class="text-primary">
      We work in age groups
      <br>with personalised exercises
    </h2>
    <div class="row justify-content-center mx-auto">
      <div class="col-12 col-md-4 p-4">
        <div class="year bg-white p-4">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-1.png" alt="Year 5-11 english classes" class="mx-auto py-3">
          <div class="heading text-secondary">5-11</div>
          <p class="sub-heading">YEARS</p>
          <p class="description">
            We have 5 different levels for kids learning English from ages 5-11, based not just on the student’s age but also their level of English and their own particular needs.
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-5-11-years-old-kids/">
            Learn More
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-4 p-4">
        <div class="year bg-white p-4">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-2.png" alt="Year 12-19 english classes" class="mx-auto py-3">
          <div class="heading text-secondary">12-19</div>
          <p class="sub-heading">YEARS</p>
          <p class="description">
            We have 7 levels for students aged 12-19, with each level focusing in greater depth on the key skills of writing, speaking, reading and listening.
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-12-19-years-old-kids/">
            Learn More
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-4 p-4">
        <div class="year bg-white p-4">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-3.png" alt="Adult english classes" class="mx-auto py-3">
          <div class="heading text-secondary">Adult</div>
          <p class="sub-heading">YEARS</p>
          <p class="description">
            Here at English Matters we offer you a unique opportunity to learn at your own pace and in accordance with your own particular needs.
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-adults/">
            Learn More
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-8 p-4">
        <div class="year bg-white p-4">
          <div class="heading text-secondary" style="font-size: 3.5em;">Creative Writing Classes</div>
          <p class="sub-heading">for ages 5 to 17</p>
          <p class="description mx-auto" style="max-width: 360px;">
            Nurture your child’s storytelling and writing skills! Join our Creative Writing classes to inspire the writer within.
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/school-holidays-english-class/">
            Learn More
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <div id="testimonials" class="container py-5">
    <h4 class="text-primary text-center">Endorsements from some of our current and previous students about our English teaching methods.</h4>

    <div class="row m-0">
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>
            There are brilliant English teachers here. I personally enjoy the approach they use on their courses to create a fun learning experience.
          </p>
          <div class="author text-secondary">
            Hong Wei
          </div>
          <div class="author-details">
            18 years old
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>
            We are so happy to see ... both of [our children] gaining confidence and showing great progress in their English language skills throughout the years.  We really appreciate all the support and help from teachers and staff.
          </p>
          <div class="author text-secondary">
            Ching Ching
          </div>
          <div class="author-details">
            Parents of 2 children at English Matters for over 4 years
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>
            The discussions and debates we did in class really prepared me for my scholarship interview - it gave me the confidence I needed.
          </p>
          <div class="author text-secondary">
            Samuel
          </div>
          <div class="author-details">
            Current law undergraduate at UK's Manchester University and former English Matters' student
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>
            Their teaching methods are very effective. I don't dread coming for tuition.
          </p>
          <div class="author text-secondary">
            H'ng Wei
          </div>
          <div class="author-details">
            at English Matters for over 2 years
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>
            The activities are fun... The English speaking and reading exercises are challenging and the teachers are great at teaching. Also, my English grammar and writing have vastly improved.
          </p>
          <div class="author text-secondary">
            Hazel
          </div>
          <div class="author-details">
            at English Matters for more than 8 years
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>
            This English language course has inspired me to take up more languages.
          </p>
          <div class="author text-secondary">
            Ingrid
          </div>
          <div class="author-details">
            at English Matters for 4 years
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="prospectus">
    <div class="container text-center text-md-start">
      <p class="fw-bold text-secondary">
        DOWNLOAD OUR LATEST FLYER
      </p>
      <h4 class="text-primary">
        2025 flyer
      </h4>
      <a href="https://english-matters.s3.ap-southeast-1.amazonaws.com/files/English+Matters+2025+Program+Brochure.pdf" 
        target="_blank"
        class="btn btn-primary">Download</a>
    </div>
  </div>

  <div id="history">
    <div class="container">
      <div class="row m-0">
        <div class="col-12 col-md-6">
          <div class="sub-container-1">
            <h4 class="text-secondary text-center">1999</h4>
            <p class="text-primary tf-dm-serif">
              We have been teaching English in Petaling Jaya to students of all ages since 1999
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="sub-container-2">
            <p class="text-primary"><strong>
              We run all levels of English courses, for students of all ages, and we pride ourselves on the personal touch, combining the highest- quality professional teaching with a strong commitment to seeing our students become more confident and proficient with the English language.
            </strong></p>
            <p>
              The vast majority of our students stay with us for a number of years - and so it's very important to me that our teachers also stay with English Matters for a long time.
            </p>

            <router-link class="btn btn-primary px-4 mt-4" to="/about-english-matters">Learn More</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  // If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
  import 'vue3-carousel/carousel.css'
  import { Carousel, Slide } from 'vue3-carousel'

  const carouselConfig = {
    itemsToShow: 1,
    wrapAround: true,
    autoplay: 3000,
    snapAlign: 'center',
    height: '400px',
    gap: 5,
    breakpoints: {
      0: { itemsToShow: 1 },
      500: { itemsToShow: 2 },
      768: { itemsToShow: 3 },
      1200: { itemsToShow: 5 },
    }
  }
</script>

<script>
  import WhyUs from '../components/WhyUs.vue';
  export default {
    components: { WhyUs },
    data() {
      return {
        slides: [
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Nas+with+student.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Student+Discussion.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Word+games.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Happy+students.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Student+Discussion+2.webp"
        ]
      };
    }
  };
</script>

<style scoped>
  #jumbotron {
    background-color: #2e1aaf;
    min-height: 85vh;
    background-image: url('https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/jumbotron.png');
    background-position: right bottom -200px;
    background-repeat: no-repeat;
    background-size: 100vw auto;
    width: 100%;
    color: white;
  }
  @media (max-width: 800px) {
    #jumbotron {
      background-position: right bottom;
    }
  }

  #bubble {
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/bubble.png");
    background-position: left -145px top 100px;
    background-repeat: no-repeat;
    background-size: 400px;
  }
  #bubble .text {
    margin-top: 110px;
    margin-left: 85px;
    width: 130px;
  }
  #bubble .title {
    font-size: 2.5em;
  }
  #bubble p {
    font-size: 0.9em;
    color: #21147c;
  }

  #welcome { margin-top: 10vh; padding-bottom: 10vh; }
  #welcome h1 { font-size: 4em; }
  #welcome p { font-size: 1.8em; }

  #about h2 { font-size: 3.5em; }
  #about p { font-size: 1.2em; }

  #classes {
    background-color: #F4F3F9;
    margin-top: -150px;
    padding-top: 200px;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/human-bubble-2.png");
    background-position: right -10px top 400px;
    background-repeat: no-repeat;
    background-size: 1600px;
  }
  #classes h2 { font-size: 3.5em; }
  #classes p { font-size: 1.2em; }
  #classes .year { border-radius: 15px; }
  #classes .year .heading { 
    font-size: 5em; 
    font-weight: 400;
    font-family: "DM Serif Display", serif;
  }
  #classes .row {
    max-width: 1200px;
  }
  #classes .year .sub-heading { 
    font-size: 1.2em; 
    color: #B2Aecc;
    font-weight: 700;
  }

  #testimonials { max-width: 1100px; }
  #testimonials h4 { font-size: 2.5em; }
  #testimonials .testimony {
    padding: 24px 48px 24px 24px;
    background-position: 95% 8px;
    background-repeat: no-repeat;
    background-size: 40px auto;
    border-style: solid;
    border-width: 5px 5px 5px 5px;
    border-color: #F4F3F9;
    border-radius: 25px 25px 25px 25px;
    height: 100%;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/quote-symbol.webp");
    background-position: right 10px top 10px;
    background-repeat: no-repeat;
  }
  #testimonials .testimony .author {
    font-weight: bold;
  }
  #testimonials .testimony .author-details {
    font-style: italic;
    font-size: 0.9em;
  }

  #prospectus {
    background-color: #F4F3F9;
    min-height: 500px;
    padding-top: 200px;
    padding-bottom: 200px;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/consultation.png");
    background-position: left bottom;
    background-repeat: no-repeat;
  }
  #prospectus .container {
    max-width: 1000px;
  }
  #prospectus h4 { font-size: 3.5em; }
  #prospectus p { font-size: 1.2em; }

  #history {
    min-height: 700px;
    padding-top: 100px;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/discussion.png");
    background-position: left bottom 20px;
    background-repeat: no-repeat;
  }
  @media (max-width: 1200px) {
    #history {
      background-image: none;
    }
  }
  #history .sub-container-1 {
    max-width: 450px;
    margin: auto;
  }
  #history .sub-container-1 h4 { font-size: 8em; }
  #history .sub-container-1 p { font-size: 1.5em; }
  #history .sub-container-2 {
    padding: 4em 0;
    max-width: 300px;
    margin: auto;
  }
</style>
